import {
  FETCH_MASTER_CONFIG_PENDING,
  FETCH_MASTER_CONFIG_REJECTED,
  FETCH_MASTER_CONFIG_FULFILLED,
  FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_FULFILLED,
} from "../../constants/masterConfig";

const initialState = {
  loading: false,
  error: false,
  success: false,
  data: null,
};

const masterConfig = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MASTER_CONFIG_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: state.data ?? null,
      };
    case FETCH_MASTER_CONFIG_REJECTED:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        data: null,
      };
    case FETCH_MASTER_CONFIG_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action.payload.data,
      };
    case FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          Prizes: action.payload?.data?.Prizes,
          Tnc: action.payload?.data?.Tnc,
        },
      };
    default:
      return state;
  }
};

export default masterConfig;
